import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { USER_LIST } from 'src/constants/queryKeys';

export const networkGetUserList = async (payload, PageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`Profile/List/${PageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchUserList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [USER_LIST, pageIndex, payload],
    queryFn: () => networkGetUserList(payload, pageIndex, pageSize),
  });
}

export const networkUpdateUserInfo = async (payload) => {
  const res = await axiosInstance.post('Profile/Update', payload);
  return res;
};
